import React from 'react';
import { setNewsletterSubmitCookie } from './cookie';
import { __ } from '../../../../utils/translation-service';
import { validateEmail } from './validateEmail';
import { post } from '../../header/header-mobile-old/http';
import { LocaleConfigContext } from '../../../../contexts/locale-config/locale-config';
import { ILocaleConfig } from '@interfaces';

/* Duplication of messages and inline styles are used to
achieve compatibility with angular search page*/
const LoadingIndicator = () => (
    <span className="newsletter_loading" style={{ display: 'inline' }} />
);

export const SuccessRegistrationMessage = () => (
    <div
        id="footer_newsletter_input_success"
        style={{ display: 'inline' }}
        className="footer_newsletter_client_feedback text-danger newsletter_message errorBlock col-xs-12"
    >
        {__('newsletterMessage1')}
    </div>
);

export const InvalidEmailMessage = () => (
    <div
        id="footer_newsletter_input_error_mail_empty"
        style={{ display: 'inline' }}
        className="footer_newsletter_client_feedback text-danger newsletter_message errorBlock col-xs-12"
    >
        {__('newsletterMessage2')}
    </div>
);

const AlreadyRegisteredMessage = () => (
    <div
        id="footer_newsletter_input_error"
        style={{ display: 'inline' }}
        className="footer_newsletter_client_feedback text-danger newsletter_message errorBlock col-xs-12"
    >
        {__('newsletterMessage3')}
    </div>
);

const NetworkErrorMessage = () => (
    <div
        id="footer_newsletter_input_error_not_valid_format"
        style={{ display: 'inline' }}
        className="footer_newsletter_client_feedback text-danger newsletter_message errorBlock col-xs-12"
    >
        {__('newsletterMessage4')}
    </div>
);

interface INewsletterFormProps {
    messageCode?: number;
    isLoading?: boolean;
    email: string;
}

/**
 * Component responsible for email registration in footer
 * this.state.messageCode defines message under registration form
 * messagesCodes:
 * 0 - none, 1 - success, 2 - mail error, 3 - already registered, 4 - network error
 *
 */
export class NewsletterForm extends React.Component<INewsletterFormProps, INewsletterFormProps> {
    static contextType = LocaleConfigContext;

    declare context: React.ContextType<typeof LocaleConfigContext>;

    public static defaultProps: INewsletterFormProps = {
        messageCode: 0,
        isLoading: false,
        email: '',
    };

    public constructor(props: INewsletterFormProps) {
        super(props);
        this.state = { ...props };
    }

    public handleSubmitClick() {
        const localeConfig: ILocaleConfig = this.context;
        if (!validateEmail(this.state.email)) {
            return this.setState({ messageCode: 2 });
        }
        const config = {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        };
        const formData = `action=newsletter&email=${encodeURIComponent(
            this.state.email || '',
        )}&headerTitle=`;
        this.setState({ isLoading: true, messageCode: 0 });
        post(
            `https://www.${localeConfig.url}/wp-content/themes/dreamlines/ajax/ajaxhandler.php`,
            formData,
            //@ts-ignore // @TODO: does not fit the function type. probably is doing nothing
            config,
        ) //@TODO Should we handle this?
            .then((_response: any) => {
                setNewsletterSubmitCookie();
                this.setState({ messageCode: 1, isLoading: false });
            })
            .then(() => {
                // UserIdentification.setCustomer(this.state.email);
            })
            .catch((error: any) => {
                if (error.response && error.response.status) {
                    this.setState({
                        messageCode: error.response.status === 400 ? 3 : 4,
                        isLoading: false,
                    });
                } else {
                    this.setState({ messageCode: 4, isLoading: false });
                }
            });
    }
    public changeEmail(event: any) {
        this.setState({ email: event.target.value });
    }

    public getMessage() {
        switch (this.state.messageCode) {
            case 1:
                return <SuccessRegistrationMessage />;
            case 2:
                return <InvalidEmailMessage />;
            case 3:
                return <AlreadyRegisteredMessage />;
            case 4:
                return <NetworkErrorMessage />;
        }
    }

    public render() {
        const inputClasses = `col-xs-12 footer-newsletter__input ${
            this.state.messageCode === 2 && 'footer-newsletter__input--invalid'
        }`;

        return (
            <div className="col-xs-12 col-sm-5 col-md-6 footer-newsletter">
                <form
                    className="footer_newsletter_form col-xs-12 noPadding footer_newsletter_container"
                    style={{ display: this.state.messageCode !== 1 ? 'block' : 'none' }}
                >
                    <div className="col-xs-8 col-lg-9">
                        <input
                            type="text"
                            className={inputClasses}
                            id="footer_newsletter_input"
                            name="EMAIL"
                            placeholder={__('yourEmailAddress')}
                            required
                            data-type="mail"
                            value={this.state.email}
                            onChange={this.changeEmail.bind(this)}
                            data-test-id="newsletterEmail"
                            style={{ border: '2px white solid' }}
                        />
                    </div>
                    <div className="col-xs-4 col-lg-3 noPadding">
                        <button
                            id="footer_newsletter_button"
                            type="button"
                            className="btn btn-more col-xs-12 noPadding LineNewsletterFormButton"
                            name="sup"
                            onClick={this.handleSubmitClick.bind(this)}
                            data-test-id="newsletterSubmitButton"
                        >
                            {__('send')}
                        </button>
                        <span className="newsletter_loading" />
                        {this.state.isLoading && <LoadingIndicator />}
                    </div>
                    <div
                        id="footer_newsletter_input_success"
                        data-test-id="newsletterMessage"
                        className="footer_newsletter_client_feedback text-danger newsletter_message errorBlock col-xs-12"
                    >
                        {__('newsletterMessage1')}
                    </div>
                    <div
                        id="footer_newsletter_input_error_mail_empty"
                        className="footer_newsletter_client_feedback text-danger newsletter_message errorBlock col-xs-12"
                    >
                        {__('newsletterMessage2')}
                    </div>
                    <div
                        id="footer_newsletter_input_error"
                        className="footer_newsletter_client_feedback text-danger newsletter_message errorBlock col-xs-12"
                    >
                        {__('newsletterMessage3')}
                    </div>
                    <div
                        id="footer_newsletter_input_error_not_valid_format"
                        className="footer_newsletter_client_feedback text-danger newsletter_message errorBlock col-xs-12"
                    >
                        {__('newsletterMessage4')}
                    </div>
                </form>
                {this.getMessage()}
                <div className="clearfix" />
                <div
                    className="GDPRtext"
                    dangerouslySetInnerHTML={{
                        __html: __('newsletterRelatedGDPRText'),
                    }}
                />
            </div>
        );
    }
}
